import { h } from 'preact'

type Props = h.JSX.HTMLAttributes<HTMLDivElement>

const Row: preact.FunctionalComponent<Props> = ({ children, ...rest }: Props) => {
    const props = {
        ...rest,
        class: rest.class ? `row ${rest.class}` : 'row',
    }

    return <div {...props}>{children}</div>
}

export default Row
